<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<form id="FormAccion" role="form" method="post" autocomplete="off" onSubmit="return false">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
                        <div class="avatar-upload">
                            <div class="avatar-edit">
                                <input type="file" @change="$uploadImagePreview($event,ValidElement, Array('Nomimagen','ImagePreview'))" id="imageUpload" name="Imagen" ref="fileImg" accept="image/.jpg">
                                <label for="imageUpload"></label>
                            </div>
                            <div class="avatar-preview">
                                <div id="ImagePreview" style="background-image: url(images/sin_imagen_200.jpg);">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <label class="form-label" for="Descripcion">Descripción</label>
                                <textarea v-model="objImagen.Descripcion" class="form-control" id="Descripcion" placeholder="Ingresar Descripcion" rows="3"></textarea>
                                <CValidation v-if="this.errorvalidacion.Descripcion" :Mensaje="'*'+errorvalidacion.Descripcion[0]"/>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                <label class="form-label" for="Cantidad">Cantidad</label>
                                <input type="text" v-model="objImagen.Cantidad" @input="$onlyNums($event,objImagen,'Cantidad');" class="form-control" id="Cantidad" placeholder="Ingresar Cantidad" />
                                <CValidation v-if="this.errorvalidacion.Cantidad" :Mensaje="'*'+errorvalidacion.Cantidad[0]"/>
                            </div>

                            <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                <label class="form-label" for="Precio">Precio</label>
                                <div class="money">
                                    <input type="text" v-model="objImagen.Precio" @input="$number_decimal($event,objImagen,'Precio');" class="form-control text-end" id="Precio" placeholder="Ingresar Precio" />
                                </div>
                                <CValidation v-if="this.errorvalidacion.Precio" :Mensaje="'*'+errorvalidacion.Precio[0]"/>
                            </div>
                        </div>
                    </div>
                            
                </div>
			</form>
		</template>
	</CLoader>
</template>

<script>

import Configs from '@/helpers/VarConfig.js';

export default {
    name: 'FormImagen',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objImagen: {
                Nomimagen: '',
				Descripcion: '',
                Cantidad: '',
                Precio: '',

                IdDetalleCotizacion: 0,
                IdCotizacionEvento: 0,
                IdImagenCopia: 0,
                IdArticuloAlmacen: 0,
                DescripcionIngles: '',
                Notas: '',
                TotalIndividual: '',
                Moneda: '',
                Anexado: 1,
                TipoMoneda: 'MXN',
                FYM: '',
                EstiloIng: false,
                EstiloEsp: true,
                EstiloNot: false,
                UrlImagen: '',
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
            ValidElement: Configs.validImage5m,
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0;
            this.poBtnSave.DisableBtn = true;

            let errores = 0;
			let msg = 'El campo es requerido';
			let objError = {};


            if(this.objImagen.Descripcion == '')    { objError.Descripcion  = [msg]; errores++;	}
			if(this.objImagen.Cantidad == '')		{ objError.Cantidad 	= [msg]; errores++;	}
			if(this.objImagen.Precio == '')			{ objError.Precio 		= [msg]; errores++;	}

            if(errores>0)
			{
				this.errorvalidacion = objError;
				this.poBtnSave.DisableBtn = false;
				this.$toast.warning('Complete los campos obligatorios');
				return false;
			}

            let formData = new FormData();
            let Imagen = this.$refs.fileImg.files[0];

            if(Imagen === undefined){
                this.$toast.warning('Debe agregar una imagen');
                return false;
            }

            formData.append('Imagen',Imagen);
            formData.set('TipoImagen','Carga');

			await this.$http.post('solicitudImagen', formData,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((res)=>{
                this.EjecutaConExito(res);
            }).catch(err=>{
                this.EjecutaConError(err);
            });
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.objImagen.Nomimagen = res.data.data;

            this.objImagen.IdDetalleCotizacion = 0;
            this.objImagen.IdCotizacionEvento = 0;
            this.objImagen.IdImagenCopia = 0;
            this.objImagen.IdArticuloAlmacen = 0;
            this.objImagen.DescripcionIngles = '';
            this.objImagen.Notas = '';
            this.objImagen.TotalIndividual = '';
            this.objImagen.Moneda = '';
            this.objImagen.Anexado = 1;
            this.objImagen.TipoMoneda = 'MXN';
            this.objImagen.FYM = '';
            this.objImagen.EstiloIng = false;
            this.objImagen.EstiloEsp = true;
            this.objImagen.EstiloNot = false;
            this.objImagen.UrlImagen = res.data.ruta;

            this.bus.$emit('SetearImagen',this.objImagen);
            this.bus.$emit('CloseModal_'+this.Emit);
            //this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Limpiar()
        {
            this.objImagen = {
                Nomimagen: '',
				Descripcion: '',
                Cantidad: '',
                Precio: '',

                IdDetalleCotizacion: 0,
                IdCotizacionEvento: 0,
                IdImagenCopia: 0,
                IdArticuloAlmacen: 0,
                DescripcionIngles: '',
                Notas: '',
                TotalIndividual: '',
                Moneda: '',
                Anexado: 1,
                TipoMoneda: 'MXN',
                FYM: '',
                EstiloIng: false,
                EstiloEsp: true,
                EstiloNot: false,
                UrlImagen: '',
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            this.ConfigLoad.ShowLoader = false;
        });
    }
}
</script>
